import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'alcada');

const alcadaActions = {
  ...genericActions(basePath),
  listarTiposFluxo: { method: 'GET', url: `${basePath}/tipos-fluxo/?workflowTipo={nome}&colunaOrdenacao=nome` },
  listarAtivos: { method: 'GET', url: `${basePath}/ativos/tipos-fluxo/{id}` },
  ativarInativarRegistros: { method: 'POST', url: `${basePath}/ativarInativarRegistros` },
};

export default resource => resource(`${basePath}`, {}, alcadaActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/alcada.js